class CandidateDocumentsController {
    /*@ngInject*/
    constructor($rootScope, $timeout, $uibModal, companyService, documentService, alertsAndNotificationsService, modalService, documentActionService, MESSAGECONSTANTS, sharedAjsService) {
        this.$rootScope = $rootScope;
        this.$timeout = $timeout;
        this.$uibModal = $uibModal;
        this.companyService = companyService;
        this.documentService = documentService;
        this.modalService = modalService;
        this.alertsAndNotificationsService = alertsAndNotificationsService;
        this.documentActionService = documentActionService;
        this.MESSAGECONSTANTS = MESSAGECONSTANTS;
        this.sharedAjsService = sharedAjsService;
    }
    $onInit() {
        this.userId = this.$rootScope.userDetails.id;
        this.companyId = this.$rootScope.userDetails.company.companyId;
        this.isCorporate = this.companyService.isCorporateCompany();
        this.loadingFolders = true;
        this.isSharedDocumentActionAvailable = true;
        this.folders = [];
        this.allFoldersList = [];
        this.candidateJobMatchFolders = [];
        this.allAvailableDocuments = [];
        this.companiesToShareCandidateDocuments = [];
        this.getAllCandidateFolders(() => {
            if (this.folders.length > 0) {
                if (this.candidateDetails && this.candidateDetails.folderId && this.candidateDetails.isNotification) {
                    this.onFolderSelect(this._getFolderById(this.candidateDetails.folderId));
                }
                else {
                    this.onFolderSelect(this.folders[0]);
                }
            }
        });
    }
    _setCandidateJobMatchFolders(jobMatches) {
        this.candidateJobMatchFolders = [];
        this.candidateJobMatchFolders = this.documentActionService.setCandidateJobMatchFolders(jobMatches, this.companyId, this.candidateId);
    }
    _setAllAvailableDocumentsInfolders() {
        let allDocuments = [];
        let parentDocuments = [];
        let childDocuments = [];
        this.folders.forEach(folder => {
            parentDocuments = [...folder.documents];
            childDocuments = [];
            folder.folders.forEach(subFolder => {
                childDocuments = [...childDocuments, ...subFolder.documents];
            });
            allDocuments = [...allDocuments, ...parentDocuments, ...childDocuments];
        });
        this.candidateJobMatchFolders.map(jobMatchFolder => {
            if (jobMatchFolder.documents.length > 0) {
                allDocuments.push(...jobMatchFolder.documents);
            }
        });
        this.allAvailableDocuments = allDocuments;
    }
    getAllCandidateFolders(successCallback) {
        this.documentService.getAllCandidateFolders(this.candidateId, this.companyId, this.candidateType, (data) => {
            this._setFolders(data.candidateDocuments);
            this._setDocumentSharedOption(data);
            this._setCandidateJobMatchFolders(data.jobMatchesDocuments);
            this._setAllAvailableDocumentsInfolders();
            this.folders = this.documentActionService.setSharedFolderWithDocuments(this.folders, this.candidateId, this.companyId);
            this.companiesToShareCandidateDocuments = this.setCompaniesToSharedCandidateDocuments(data);
            this.loadingFolders = false;
            if (successCallback) {
                successCallback();
            }
        }, error => {
            this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
        });
    }
    _setFolders(folders) {
        this.folders = [];
        folders.forEach(folder => {
            this.allFoldersList.push(folder);
            folder.folders.forEach(subFolder => {
                subFolder.parentFolderId = folder.id;
                subFolder.parentFolderName = folder.name;
                this.allFoldersList.push(subFolder);
            });
        });
        this.folders = folders;
        this.documentActionService._setDocumentIcons(this.folders);
    }
    onFolderSelect(selectedFolder) {
        this.selectedFolder = selectedFolder;
        if (selectedFolder && selectedFolder.isJobMatchFolders) {
            this.candidateJobMatchFolders.map(jobMatchFolder => {
                jobMatchFolder.active = jobMatchFolder.id === selectedFolder.id;
            });
        }
        else {
            if (this.folders.length > 0) {
                this.folders.forEach(folder => {
                    folder.active = folder.id === (selectedFolder && selectedFolder.id);
                    folder.folders.forEach(sub => {
                        sub.active = sub.id === (selectedFolder && selectedFolder.id);
                    });
                });
            }
        }
    }
    addDocumentFolder(parentFolder) {
        let actionType = 'addEditDocumentFolder';
        let actionLabel = 'Add Document Folder';
        this.modalService.addModalOpenClassToBodyIfAnyModalIsOpen();
        $(".modal").addClass("candidate-profile-modal");
        this.$timeout(() => {
            let candidateProfileActionsModal = this.$uibModal.open({
                animation: true,
                ariaLabelledBy: 'modal-title',
                ariaDescribedBy: 'modal-body',
                backdrop: 'static',
                windowTopClass: 'four-dot-five-modal-medium',
                component: 'candidateProfileActionsModal',
                resolve: {
                    actionType: () => {
                        return actionType;
                    },
                    actionLabel: () => {
                        return actionLabel;
                    },
                    parentFolderName: () => {
                        return parentFolder ? parentFolder.name : null;
                    },
                    folder: () => {
                        return new Folder("", "", parentFolder ? parentFolder.id : null, this.companyId, this.candidateId);
                    },
                    folders: () => {
                        return this.folders;
                    }
                }
            });
            candidateProfileActionsModal.result.then((callbackObject) => {
                this.getAllCandidateFolders(() => {
                    if (callbackObject && callbackObject.entity && callbackObject.entity.id) {
                        this.onFolderSelect(this._getFolderById(callbackObject.entity.id));
                    }
                    else if (this.selectedFolder && this.selectedFolder.id && !this.selectedFolder.isJobMatchFolders) {
                        this.onFolderSelect(this._getFolderById(this.selectedFolder.id));
                    }
                    else {
                        this.onFolderSelect(this.folders[0]);
                    }
                });
            }, (dismiss) => {
                //do nothing;
            });
        }, 300);
    }
    _getFolderById(folderId) {
        let parentFolder = this.folders.find(folder => folder.id === folderId);
        if (parentFolder) {
            return parentFolder;
        }
        for (let i = 0; i < this.folders.length; i++) {
            let folder = this.folders[i];
            let subFolder = folder.folders.find(subFolder => subFolder.id === folderId);
            if (subFolder !== undefined) {
                return subFolder;
                break;
            }
        }
    }
    editDocumentFolder(folder) {
        let actionType = 'addEditDocumentFolder';
        let actionLabel = 'Edit Document Folder';
        this.modalService.addModalOpenClassToBodyIfAnyModalIsOpen();
        $(".modal").addClass("candidate-profile-modal");
        this.$timeout(() => {
            let candidateProfileActionsModal = this.$uibModal.open({
                animation: true,
                ariaLabelledBy: 'modal-title',
                ariaDescribedBy: 'modal-body',
                backdrop: 'static',
                windowTopClass: 'four-dot-five-modal-medium',
                component: 'candidateProfileActionsModal',
                resolve: {
                    actionType: () => {
                        return actionType;
                    },
                    actionLabel: () => {
                        return actionLabel;
                    },
                    folder: () => {
                        return _.cloneDeep(folder);
                    },
                    folders: () => {
                        return this.folders;
                    }
                }
            });
            candidateProfileActionsModal.result.then((callbackObject) => {
                this.getAllCandidateFolders(() => {
                    this.onFolderSelect(this._getFolderById(folder.id));
                });
            }, (dismiss) => {
            });
        }, 300);
    }
    moveDocumentFolder(folder) {
        let spreadFolders = [];
        this.folders.forEach(parentFolder => {
            if (this._notCurrentAndParentFolder(parentFolder, folder)) {
                spreadFolders.push(parentFolder);
            }
            folder.folders.forEach(subFolder => {
                if (this._notCurrentAndParentFolder(subFolder, folder)) {
                    spreadFolders.push(subFolder);
                }
            });
        });
        if (folder.parentFolderId) {
            spreadFolders.push({ name: "Root", id: "root" });
        }
        if (spreadFolders.length === 0) {
            this.alertsAndNotificationsService.showAlert("No folders found", "No folders available.", "warning");
        }
        else {
            let actionType = 'moveDocumentFolder';
            let actionLabel = 'Move Folder';
            this.modalService.addModalOpenClassToBodyIfAnyModalIsOpen();
            $(".modal").addClass("candidate-profile-modal");
            this.$timeout(() => {
                let candidateProfileActionsModal = this.$uibModal.open({
                    animation: true,
                    ariaLabelledBy: 'modal-title',
                    ariaDescribedBy: 'modal-body',
                    backdrop: 'static',
                    windowTopClass: 'four-dot-five-modal-medium',
                    component: 'candidateProfileActionsModal',
                    resolve: {
                        actionType: () => {
                            return actionType;
                        },
                        actionLabel: () => {
                            return actionLabel;
                        },
                        folder: () => {
                            return folder;
                        },
                        parentFolders: () => {
                            return spreadFolders;
                        }
                    }
                });
                candidateProfileActionsModal.result.then((callbackObject) => {
                    // if(callbackObject.entity.id){
                    this.getAllCandidateFolders(() => {
                        this.onFolderSelect(this.folders[0]);
                    });
                    // }
                }, (dismiss) => {
                });
            }, 300);
        }
    }
    _notCurrentAndParentFolder(folder, folderToMove) {
        return folder.id !== folderToMove.id && folder.id !== folderToMove.parentFolderId && folder.parentFolderId !== folderToMove.id && folder.id !== 'sharedFolder';
    }
    moveDocument(document) {
        let spreadFolders = [];
        this.folders.forEach(parentFolder => {
            if (parentFolder.id !== document.folderId && parentFolder.id !== 'sharedFolder') {
                spreadFolders.push(parentFolder);
            }
            parentFolder.folders.forEach(subFolder => {
                if (subFolder.id !== document.folderId) {
                    spreadFolders.push(subFolder);
                }
            });
        });
        if (spreadFolders.length === 0) {
            this.alertsAndNotificationsService.showAlert("No folders found", "No folders available.", "warning");
        }
        else {
            let sharedTo = document && document.sharedTo ? document.sharedTo.map(document => document.id) : [];
            let actionType = 'moveDocument';
            let actionLabel = 'Move Document';
            this.modalService.addModalOpenClassToBodyIfAnyModalIsOpen();
            $(".modal").addClass("candidate-profile-modal");
            this.$timeout(() => {
                let candidateProfileActionsModal = this.$uibModal.open({
                    animation: true,
                    ariaLabelledBy: 'modal-title',
                    ariaDescribedBy: 'modal-body',
                    backdrop: 'static',
                    windowTopClass: 'four-dot-five-modal-medium',
                    component: 'candidateProfileActionsModal',
                    resolve: {
                        actionType: () => {
                            return actionType;
                        },
                        actionLabel: () => {
                            return actionLabel;
                        },
                        document: () => {
                            return new DocumentFile(document.id, document.fileName, "", this.candidateId, this.companyId, document.note, document.folderId, document.shared, "", sharedTo);
                        },
                        parentFolders: () => {
                            return spreadFolders;
                        },
                        candidateType: () => {
                            return this.candidateType;
                        },
                        allFoldersList: () => {
                            return this.allFoldersList;
                        },
                        candidateDetails: () => {
                            return this.candidateDetails;
                        }
                    }
                });
                candidateProfileActionsModal.result.then((callbackObject) => {
                    if (callbackObject.entity && callbackObject.entity.id) {
                        this.getAllCandidateFolders(() => {
                            this.onFolderSelect(this._getFolderById(this.selectedFolder.id));
                        });
                    }
                }, (dismiss) => {
                    //do nothing
                });
            }, 300);
        }
    }
    deleteDocument(document) {
        this.documentActionService.setParentAndChildFolderName(this.allFoldersList, document);
        let deleteDocumentPayload = {};
        deleteDocumentPayload.candidateId = this.candidateId;
        deleteDocumentPayload.companyId = this.companyId;
        deleteDocumentPayload.folderId = document.folderId;
        deleteDocumentPayload.documentId = document.id;
        deleteDocumentPayload.userId = this.userId;
        deleteDocumentPayload.candidateType = this.candidateType;
        deleteDocumentPayload.keepLastVersion = false;
        deleteDocumentPayload.folderName = document.folderName;
        deleteDocumentPayload.parentFolderName = document.parentFolderName;
        deleteDocumentPayload.sharedEntityIds = document && document.sharedTo ? document.sharedTo.map(document => document.id).toString() : "";
        if (this.candidateDetails.jobMatchId) {
            deleteDocumentPayload.jobMatchId = this.candidateDetails.jobMatchId;
        }
        if (document.version === 1) {
            const message = "Are you sure you want to delete the document?";
            this.modalService.addModalOpenClassToBodyIfAnyModalIsOpen();
            this.alertsAndNotificationsService.showConfirm("Delete Document", message, "warning", false, () => {
                deleteDocumentPayload.keepLastVersion = false;
                this.documentService.deleteCandidateDocument(deleteDocumentPayload, () => {
                    this.getAllCandidateFolders(() => {
                        this.onFolderSelect(this._getFolderById(this.selectedFolder.id));
                    });
                    this.modalService.addModalOpenClassToBodyIfAnyModalIsOpen();
                }, (error) => {
                    this.alertsAndNotificationsService.showBannerMessage(error.message, "danger");
                    this.modalService.addModalOpenClassToBodyIfAnyModalIsOpen();
                });
            }, () => {
                //do nothing
                this.modalService.addModalOpenClassToBodyIfAnyModalIsOpen();
            });
        }
        else {
            //delete candidate document
            let actionType = 'deleteDocument';
            let actionLabel = 'Delete Document';
            this.modalService.addModalOpenClassToBodyIfAnyModalIsOpen();
            $(".modal").addClass("candidate-profile-modal");
            this.$timeout(() => {
                let candidateProfileActionsModal = this.$uibModal.open({
                    animation: true,
                    ariaLabelledBy: 'modal-title',
                    ariaDescribedBy: 'modal-body',
                    backdrop: 'static',
                    windowTopClass: 'four-dot-five-modal-small',
                    component: 'candidateProfileActionsModal',
                    resolve: {
                        actionType: () => {
                            return actionType;
                        },
                        actionLabel: () => {
                            return actionLabel;
                        },
                        document: () => {
                            return new DocumentFile(document.id, document.fileName, "", this.candidateId, this.companyId, document.note, document.folderId, document.shared, "", []);
                        },
                        deleteDocumentPayload: () => {
                            return deleteDocumentPayload;
                        },
                        candidateDetails: () => {
                            return this.candidateDetails;
                        }
                    }
                });
                candidateProfileActionsModal.result.then((callbackObject) => {
                    this.getAllCandidateFolders(() => {
                        if (this.selectedFolder && this.selectedFolder.id) {
                            this.onFolderSelect(this._getFolderById(this.selectedFolder.id));
                        }
                    });
                }, (dismiss) => {
                    //do nothing;
                });
            }, 300);
        }
    }
    deleteDocumentFolder(folder) {
        let message = "Are you sure you want to delete this folder?";
        let preMessage = "";
        const foldersCount = folder.folders.length;
        const documentsCount = folder.documents.length;
        if (foldersCount > 0 && documentsCount > 0) {
            let foldersMessage = foldersCount > 1 ? `There are ${foldersCount} folders` : `There is ${foldersCount} folder`;
            let documentsMessage = documentsCount > 1 ? `${documentsCount} documents` : `${documentsCount} document`;
            message = `${foldersMessage} and ${documentsMessage} in this folder.<br>${message}`;
        }
        else if (foldersCount > 0) {
            preMessage = foldersCount > 1 ? `There are ${foldersCount} folders in this folder.`
                : `There is ${foldersCount} folder in this folder.`;
            message = `${preMessage}<br>${message}`;
        }
        else if (documentsCount > 0) {
            preMessage = documentsCount > 1 ? `There are ${documentsCount} documents in this folder.`
                : `There is ${documentsCount} document in this folder.`;
            message = `${preMessage}<br>${message}`;
        }
        this.modalService.addModalOpenClassToBodyIfAnyModalIsOpen();
        this.alertsAndNotificationsService.showConfirm("Delete Folder", message, "warning", false, () => {
            this.documentService.deleteCandidateDocumentFolder(folder.id, () => {
                this.getAllCandidateFolders(() => {
                    this.onFolderSelect(this.folders[0]);
                });
            }, (error) => {
                this.alertsAndNotificationsService(error.message, "danger");
            });
            this.modalService.addModalOpenClassToBodyIfAnyModalIsOpen();
        }, () => {
            //do nothing
            this.modalService.addModalOpenClassToBodyIfAnyModalIsOpen();
        });
    }
    onAddDocument(document, action) {
        let actionType = 'uploadCandidateDocument';
        let actionLabel = 'Add Document';
        let showUpload = true;
        let windowTopClass = "four-dot-five-modal-medium";
        if (document) {
            actionLabel = 'Upload New Version';
        }
        if (action && action === "edit") {
            showUpload = false;
            actionLabel = 'Edit Document';
            windowTopClass = "four-dot-five-modal-small";
        }
        else if (action && action === "share") {
            showUpload = false;
            actionType = 'shareCandidateDocument';
            actionLabel = 'Share Document';
            windowTopClass = "four-dot-five-modal-small";
        }
        let documentToUpdate;
        let sharedTo = document && document.sharedTo ? document.sharedTo.map(document => document.id) : [];
        if (document) {
            documentToUpdate = new DocumentFile(document.id, document.fileName, "", this.candidateId, this.companyId, document.note, document.folderId, document.shared, "", sharedTo);
        }
        else {
            documentToUpdate = new DocumentFile(null, "", "", this.candidateId, this.companyId, "", this.selectedFolder.id, false, "", []);
        }
        this.modalService.addModalOpenClassToBodyIfAnyModalIsOpen();
        $(".modal").addClass("candidate-profile-modal");
        this.$timeout(() => {
            let candidateProfileActionsModal = this.$uibModal.open({
                animation: true,
                ariaLabelledBy: 'modal-title',
                ariaDescribedBy: 'modal-body',
                backdrop: 'static',
                windowTopClass: windowTopClass,
                component: 'candidateProfileActionsModal',
                resolve: {
                    actionType: () => {
                        return actionType;
                    },
                    actionLabel: () => {
                        return actionLabel;
                    },
                    document: () => {
                        return documentToUpdate;
                    },
                    showUpload: () => {
                        return showUpload;
                    },
                    candidateType: () => {
                        return this.candidateType;
                    },
                    candidateDetails: () => {
                        return this.candidateDetails;
                    },
                    allFoldersList: () => {
                        return this.allFoldersList;
                    },
                    isSharedDocumentActionAvailable: () => {
                        return this.isSharedDocumentActionAvailable;
                    },
                    companiesToShareCandidateDocuments: () => {
                        return this.companiesToShareCandidateDocuments;
                    }
                }
            });
            candidateProfileActionsModal.result.then((callbackObject) => {
                this.getAllCandidateFolders(() => {
                    this.onFolderSelect(this._getFolderById(this.selectedFolder.id));
                });
            }, (dismiss) => {
                //do nothing;
            });
        }, 300);
    }
    mailDocument(document) {
        let actionType = 'emailDocument';
        let actionLabel = 'Email Document';
        let windowTopClass = "four-dot-five-modal-extra-large";
        let documentToMail = document.isJobMatchDocument ? document : new DocumentFile(document.id, document.fileName, "", this.candidateId, this.companyId, document.note, document.folderId, document.shared, "", []);
        this.modalService.addModalOpenClassToBodyIfAnyModalIsOpen();
        $(".modal").addClass("candidate-profile-modal");
        this.$timeout(() => {
            let candidateProfileActionsModal = this.$uibModal.open({
                animation: true,
                ariaLabelledBy: 'modal-title',
                ariaDescribedBy: 'modal-body',
                backdrop: 'static',
                windowTopClass: windowTopClass,
                component: 'candidateProfileActionsModal',
                resolve: {
                    actionType: () => {
                        return actionType;
                    },
                    actionLabel: () => {
                        return actionLabel;
                    },
                    documents: () => {
                        return _.cloneDeep(this.allAvailableDocuments);
                    },
                    document: () => {
                        return _.cloneDeep(documentToMail);
                    },
                    folders: () => {
                        return _.cloneDeep(this.folders);
                    },
                    candidateJobMatchFolders: () => {
                        return _.cloneDeep(this.candidateJobMatchFolders);
                    },
                    candidateDetails: () => {
                        return this.candidateDetails;
                    },
                    sourceScreen: () => {
                        return this.sourceScreen;
                    },
                    formalizeActivityPayload: () => {
                        return this.formalizeActivityPayload;
                    }
                }
            });
        }, 300);
    }
    _setDocumentSharedOption(folderData) {
        if (this.candidateDetails) {
            // No sharing action if requisition is internal or external from workflow
            if (this.candidateDetails.context == 'candidateJobMatchCard' && !this.candidateDetails.isSharedRequisition) {
                this.isSharedDocumentActionAvailable = false;
                // No sharing action for corporate company internal candidates
            }
            else if (this.candidateDetails.context == 'candidateCard' && this.isCorporate && this.candidateDetails.candidateType == 'OWN_CANDIDATES') {
                this.isSharedDocumentActionAvailable = false;
                // Candidate screen No sharing action for candidates not in shared requisition
            }
            else if (this.candidateDetails.context == 'candidateCard' && !this.isCorporate) {
                this.isSharedDocumentActionAvailable = folderData.sharedCandidate;
            }
        }
    }
    setCompaniesToSharedCandidateDocuments(data) {
        let companies = this.isCorporate ? data.documentToShareVendors : data.documentToShareCorporates;
        if (companies && companies.length > 1 && !this.isCorporate && this.candidateDetails.corporateName) {
            companies = companies.filter(company => this.candidateDetails.corporateName == company.name);
        }
        return companies;
    }
    viewDocumentFIle(file) {
        this.sharedAjsService.viewDocumentFIle(file, (data) => {
        }, (error) => {
        });
    }
}
CandidateDocumentsController.$inject = ['$rootScope', '$timeout', '$uibModal', 'companyService', 'documentService', 'alertsAndNotificationsService', 'modalService', 'documentActionService', 'MESSAGECONSTANTS', 'sharedAjsService'];
// import * as TEMPLATE from './candidate-documents.html';
import * as TEMPLATE from 'raw-loader!./candidate-documents.html';
export const CandidateDocumentsComponent = {
    selector: 'candidateDocuments',
    component: {
        bindings: {
            candidateId: '@',
            candidateType: '<',
            candidateDetails: '<',
            saveCallback: '&',
            cancelCallback: '&',
            sourceScreen: '@',
            formalizeActivityPayload: '<'
        },
        controller: CandidateDocumentsController,
        template: TEMPLATE.default
        // templateUrl: 'app/partials/missioncontrol/candidateprofile/candidateProfile/candidateDocuments/candidate-documents.html'
    }
};
class Folder {
    constructor(name, description, parentFolderId, companyId, candidateId) {
        this.name = name;
        this.description = description;
        this.parentFolderId = parentFolderId;
        this.companyId = companyId;
        this.candidateId = candidateId;
    }
}
class DocumentFile {
    constructor(id, name, description, candidateId, companyId, internalNote, folderId, shared, icon, sharedEntityIds) {
        this.id = id;
        this.name = name;
        this.description = description;
        this.candidateId = candidateId;
        this.companyId = companyId;
        this.internalNote = internalNote;
        this.folderId = folderId;
        this.sharedEntityIds = sharedEntityIds;
        this.shared = shared;
        this.icon = icon;
    }
}
//# sourceMappingURL=candidate-documents.component.js.map